import {
  type Active,
  type CollisionDetection,
  type Over,
  type UniqueIdentifier,
  closestCenter,
  pointerWithin,
} from "@dnd-kit/core";

export type StatusContainerId = "available" | "selected";

export const isContainerId = (id: UniqueIdentifier): id is StatusContainerId =>
  id === "available" || id === "selected";

export const getContainer = (node: Active | Over | null | undefined) =>
  node?.data.current?.container as StatusContainerId | undefined;

export const statusCollisionDetection: CollisionDetection = (args) => {
  if (!args.pointerCoordinates) {
    return closestCenter(args);
  }

  const containerHit = pointerWithin(args).find((c) => isContainerId(c.id));
  if (!containerHit) {
    return [];
  }

  const itemsInContainer = args.droppableContainers.filter(
    (c) => !isContainerId(c.id) && c.data.current?.container === containerHit.id
  );

  return itemsInContainer.length > 0
    ? closestCenter({ ...args, droppableContainers: itemsInContainer })
    : [containerHit];
};
